import { render, staticRenderFns } from "./IndicatorTablePage.vue?vue&type=template&id=405e43d3&scoped=true"
import script from "./IndicatorTablePage.vue?vue&type=script&lang=js"
export * from "./IndicatorTablePage.vue?vue&type=script&lang=js"
import style0 from "./IndicatorTablePage.vue?vue&type=style&index=0&id=405e43d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e43d3",
  null
  
)

export default component.exports